__turbopack_context__.v({
  "animate-arrow-hover": "animations-module__VStoPG__animate-arrow-hover",
  "arrow-hover": "animations-module__VStoPG__arrow-hover",
  "arrow-up-right-icon": "animations-module__VStoPG__arrow-up-right-icon",
  "popover-item": "animations-module__VStoPG__popover-item",
});
